import { authFetch } from "@/lib/api-client";

export interface StatusTimeSegment {
  status: string;
  label: string;
  durationMs: number;
  isOpen: boolean;
}

export interface EntityTiming {
  segments: StatusTimeSegment[];
  totalMs: number;
  breakdownAvailable: boolean;
  isOpen: boolean;
}

export interface OrderStatusTimeScript {
  id: string;
  title: string | null;
  timing: EntityTiming;
}

export interface OrderStatusTimeOrder {
  id: string;
  createdAt: string;
  clientName: string;
  partnerName: string;
  timing: EntityTiming;
  scripts: OrderStatusTimeScript[];
}

export interface OrderStatusTimePage {
  orders: OrderStatusTimeOrder[];
  nextCursor: string | null;
}

/** Server max page size. The view groups across every page, so each request should carry as many orders as the route allows. */
const ORDER_STATUS_TIME_PAGE_SIZE = "50";

export async function fetchOrderStatusTimeDashboard(): Promise<{ orders: OrderStatusTimeOrder[] }> {
  const { data } = await authFetch<{ orders: OrderStatusTimeOrder[] }>("/order-status-time/dashboard");
  return data;
}

export async function fetchOrderStatusTime(cursor?: string): Promise<OrderStatusTimePage> {
  const params = new URLSearchParams();
  params.set("limit", ORDER_STATUS_TIME_PAGE_SIZE);
  if (cursor) params.set("cursor", cursor);
  const qs = params.toString();
  const { data } = await authFetch<OrderStatusTimePage>(
    `/order-status-time${qs ? `?${qs}` : ""}`,
  );
  return data;
}
